import { default as isoFetch } from 'isomorphic-fetch';
import {apiError} from '../actions/application';

export function checkStatus(response) {
    if(response.status >= 200 && response.status < 300) {
        return response;
    }else {
        const error = new Error(response.statusText);
        error.response = response;
        error.status = response.status;
        throw error;
    }
}

export function handleApiError(error, dispatch, expectedErrorCallback) {
    const {response} = error;
    if(response && response.text) {
        response.text().then(function(text){
            try {
                const json = JSON.parse(text);
                const parsedError = {
                    response : json,
                    status   : response.status
                }
                if(parsedError.status !== 401 && parsedError.status !== 403) {
                    dispatch(expectedErrorCallback(parsedError));    
                }else {
                    dispatch(apiError({
                        status : 403
                    }))
                }
                
            } catch(ex) {
                dispatch(apiError({
                    status : response.status,
                    response : text,
                }));
            }
        });    
    }else {
        dispatch(apiError({
            status : -1,
            response : response ? response : error,
        }));
    }
    
}

export function addParamsToUrl(url, queryParams) {
    const params = [];
    if(queryParams) {
        for(let key in queryParams) {
            if({}.hasOwnProperty.call(queryParams, key)) {
                params.push(encodeURIComponent(key) + '=' + queryParams[key])
            }
        }

    }
    let urlWithParams = url;
    if(params.length > 0) {
        let paramsEnconded = params.join('&');
        if(url.indexOf('?') >= 0) {
            urlWithParams += '&' + paramsEnconded;
        } else {
            urlWithParams += '?' + paramsEnconded;
        }
    }
    return urlWithParams;
}


export function fetch(url, options = {}) {
    let urlWithParams ;
    if(options.queryParams) {
        urlWithParams = addParamsToUrl(url, options.queryParams);
        delete options.queryParams;   
    }else {
        urlWithParams = url;
    }
    
    
    const headers = options.headers || {};
    if(!headers['Accept']) {
        headers['Accept'] = 'application/json';
    }
    const token = sessionStorage.getItem('api_token');
    
    if(token) {
        headers['Authorization'] = 'Bearer ' + token;
    }
    options.headers = headers;

    return isoFetch(urlWithParams, options)
        .then(response => checkStatus(response));
}

function objectToFormData(object, data, prefix) {
    if(typeof object === 'string' || typeof object === 'number') {
        data.append(prefix, object);
    } else if(typeof object === 'object') {
        for(let key in object) {
            if({}.hasOwnProperty.call(object, key)) {
                objectToFormData(object[key], data, prefix ? `${prefix}[${key}]` : key);
            }
        }
    }
}

export function upload(url, files, onLoad = null, onError = null, onProgress = null, onAbort = null, data = {}, options = {}) {
    const xhr = new XMLHttpRequest();
    const formData = new FormData();
    objectToFormData(data, formData);
    const fileKey = options.fileKey || 'file';
    if(Array.isArray(files)) {
        const fileKeyArray = fileKey.endsWith('[]') ? fileKey : fileKey + '[]';
        for(let i = 0; i< files.length; i++) {
            formData.append(fileKeyArray, files[i]);    
        }    
    } else if(files instanceof File) {
        formData.append(fileKey, files);
    }else {
        for(let key in files) {
            if({}.hasOwnProperty.call(files, key)) {
                let file = files[key];
                if(file) {
                    formData.append(key, file);     
                }
                
            }
        }
    }
    

    // SET CALLBACKS
    if(onLoad || onError) {
        xhr.addEventListener("load", (evt) =>{
            if(xhr.status >= 200 && xhr.status < 300 && onLoad) {
                onLoad(evt);
            } else if(xhr.status >= 300 && onError) {
                try {
                    const json = JSON.parse(xhr.responseText);
                    onError({
                        status : xhr.status,
                        response : json,
                    });
                } catch(error) {
                    onError(error);
                }

            } 
        });
    }

    if(onProgress) {
        xhr.upload.addEventListener("progress", onProgress);
    }

    if(onError) {
        xhr.upload.addEventListener("error", () => {
            onError({
                status : 0
            })
        });
    }

    if(onAbort) {
        xhr.upload.addEventListener("abort", onAbort);
    }
    const method = options.method || 'POST';
    if(method !== 'POST') {
        formData.append('_method', method);
    }
    xhr.open('POST', url);
    xhr.setRequestHeader('Accept', 'application/json');
    const token = sessionStorage.getItem('api_token');
    if(token) {
        xhr.setRequestHeader('Authorization', 'Bearer ' + token);
    }
    
    xhr.send(formData);
    return xhr;
}



/** WEBPACK FOOTER **
 ** ./src/utils/http.js
 **/